import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { accessTokenInfoAtom, employeeInfoAtom } from "../store";

export function useDefaultPath(): string {
  const { i18n } = useTranslation();
  const [employeeInfo] = useAtom(employeeInfoAtom);
  const [tokenInfo] = useAtom(accessTokenInfoAtom);

  const isLoggedIn =
    !!employeeInfo.employee_id &&
    !!tokenInfo &&
    dayjs(tokenInfo.expired_at).isAfter(dayjs());

  return isLoggedIn
    ? `/${i18n.resolvedLanguage}/home`
    : `/${i18n.resolvedLanguage}/login`;
}
